import { render, staticRenderFns } from "./select-hotel-label.vue?vue&type=template&id=4c188ef8&scoped=true"
import script from "./select-hotel-label.vue?vue&type=script&lang=ts"
export * from "./select-hotel-label.vue?vue&type=script&lang=ts"
import style0 from "./select-hotel-label.vue?vue&type=style&index=0&id=4c188ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c188ef8",
  null
  
)

export default component.exports